(function () {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SettingFeatureController', SettingFeatureController)

    /* @ngInject */
    function SettingFeatureController($scope, $state, $q, $http, Setting, $filter, $window, Principal, ToastService) {
        var vm = this;

        vm.loadingData = false;
        vm.pageTitleKey = $state.$current.data.pageTitle;
        vm.featureSettings = null;
        vm.features = {};
        vm.isAdmin = Principal.isWorkspaceAdmin();
        vm.homePageFeatureValue = false;
        vm.originalPublicAccessFeatureValue = false;
        vm.publicAccessFeatureValue = false;

        function indexSettingsByName(settings) {
            var byName = {};
            angular.forEach(settings, function (s) {
                byName[s.name] = s;
            });
            return byName;
        }

        function applyParentChildFeatureValues(groupKey) {
            var settings = vm.features[groupKey].settings;
            var byName = vm.features[groupKey].settingsByName;
            var changed;
            do {
                changed = false;
                angular.forEach(settings, function (s) {
                    if (!s.parent_feature_name) {
                        return;
                    }
                    var p = byName[s.parent_feature_name];
                    if ((!p || !p.value) && s.value) {
                        s.value = false;
                        changed = true;
                    }
                });
            } while (changed);
        }

        vm.isChildFeatureDisabled = function (subFeature, groupKey) {
            if (!subFeature.parent_feature_name) {
                return false;
            }
            var byName = vm.features[groupKey].settingsByName;
            var cur = subFeature;
            while (cur && cur.parent_feature_name) {
                var p = byName[cur.parent_feature_name];
                if (!p || !p.value) {
                    return true;
                }
                cur = p;
            }
            return false;
        };

        function setFeaturesModel(featureSettings) {
            angular.forEach(featureSettings, function (feature) {
                if (feature.category == 'features') {
                    vm.featureSettings = feature;
                    angular.forEach(feature.fields, function (settingField) {
                        if (settingField.value == 'true') {
                            settingField.value = true;
                        } else {
                            settingField.value = false;
                        }

                        if (settingField.group_name === 'system' && settingField.name === "public_access") {
                            vm.originalPublicAccessFeatureValue = settingField.value;
                            console.log("setting vm.originalPublicAccessFeatureValue", vm.originalPublicAccessFeatureValue)
                        }
                        var feature = vm.features[settingField.group_name];
                        if (feature) {
                            feature.settings.push(settingField);
                        } else {
                            var feature = {
                                name: settingField.group_name,
                                label: settingField.group_label,
                                editable: settingField.group_editable,
                                settings: []
                            }
                            feature.settings.push(settingField);
                            vm.features[settingField.group_name] = feature;
                        }
                    });
                }
            });
            angular.forEach(vm.features, function (group) {
                group.settingsByName = indexSettingsByName(group.settings);
            });
            angular.forEach(vm.features, function (group, groupKey) {
                applyParentChildFeatureValues(groupKey);
            });
        }

        function setFeatureSettings() {
            vm.featureSettings.fields = [];
            for (var key in vm.features) {
                var feature = vm.features[key];
                angular.forEach(feature.settings, function (settingField) {
                    if (settingField.group_name == 'system' && settingField.name == 'enable_configurable_home_page') {
                        vm.homePageFeatureValue = settingField.value;
                    }

                    if (settingField.group_name == 'system' && settingField.name == 'public_access') {
                        vm.publicAccessFeatureValue = settingField.value;
                        console.log("saving vm.publicAccessFeatureValue", vm.publicAccessFeatureValue)
                    }

                    vm.featureSettings.fields.push(settingField);
                });
            }
        }

        vm.save = function () {
            setFeatureSettings();
            Setting.update(vm.featureSettings, function (result) {
                vm.featureSettings = result;
                $http.post('api/homepage/feature-flag/' + vm.homePageFeatureValue).then(function (data) { }, function (error) { });
                console.log("API", vm.originalPublicAccessFeatureValue, vm.publicAccessFeatureValue)
                if (vm.publicAccessFeatureValue !== vm.originalPublicAccessFeatureValue) {
                    $http.post('api/public-access/feature-flag/change/' + vm.publicAccessFeatureValue).then(function (data) {
                        vm.originalPublicAccessFeatureValue = vm.publicAccessFeatureValue;
                    }, function (error) { });
                }
                ToastService.displayToastWithAction($filter('triTranslate')("atheer.setting.featureSuccess"),
                    $filter('triTranslate')("entity.action.refresh"), 'md-accent', '', function (response) {
                        if (response == 'ok') {
                            $window.location.reload();
                        }
                    });
            });
        }

        $scope.handleFeatureSwitchToggle = function (feature, key) {
            // Airsdk api/data-export feature is only visible if airsdk enable feature flag is true
            if (feature.group_name === "airsdk") {
                if (feature.name !== "enable") {
                    var enableFeatureIndex = -1;
                    var isAnySubFeatureActive = false;
                    // if data-export/api feature is active then enable air-sdk feature
                    angular.forEach(vm.features[key].settings, function (
                        subFeature,
                        subFeatureIdx
                    ) {
                        if (subFeature.name !== "enable") {
                            if (subFeature.value) {
                                isAnySubFeatureActive = true;
                            }
                        } else {
                            enableFeatureIndex = subFeatureIdx;
                        }
                    });
                    if (enableFeatureIndex !== -1) {
                        vm.features[key].settings[enableFeatureIndex].value =
                            isAnySubFeatureActive;
                    }
                } else {
                    // if air-sdk enable feature flag is false then make data-export/api feature flag false
                    if (!feature.value) {
                        angular.forEach(vm.features[key].settings, function (
                            subFeature,
                            subFeatureIdx
                        ) {
                            vm.features[key].settings[
                                subFeatureIdx
                            ].value = false;
                        });
                    }
                }
            }
            applyParentChildFeatureValues(key);
        };

        vm.loadData = function () {
            vm.loadingData = true;

            $q.all([
                Setting.getFeaturesSettings().$promise
            ])
                .then(function (results) {
                    setFeaturesModel(results[0]);
                    vm.loadingData = false;
                });
        };
        vm.loadData();
    }
})();
